/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class CommunicationApiConfiguration {
  rootUrl: string = '/';
}

/**
 * Parameters for `CommunicationApiModule.forRoot()`
 */
export interface CommunicationApiConfigurationParams {
  rootUrl?: string;
}
